import { gql, useQuery } from '@apollo/client';

export const GET_CURRENT_COMPANY_POSITION = gql`
  query {
    getCurrentCompanyPosition {
      _id
      name
    }
  }
`;

export const useGetCurrentCompanyPosition = () => {
  const { data, loading } = useQuery(GET_CURRENT_COMPANY_POSITION);

  const companyPosition = data?.getCurrentCompanyPosition || {};

  return {
    loading,
    companyPosition,
  };
};
